import { render, staticRenderFns } from "./AliorModal.vue?vue&type=template&id=2e02b28d"
import script from "./AliorModal.vue?vue&type=script&lang=js"
export * from "./AliorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports